import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-default/index.css'
//import './assets/theme/theme-green/index.css'
import './assets/theme/theme-18c79c/index.css'
import './assets/icon/iconfont.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './routes'
//import Mock from './mock'

//Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

NProgress.configure({showSpinner: false});

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.path == '/login') {
        next();
        document.body.style.background = '#1F2D3D';
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('type')

    } else {
        let token = sessionStorage.getItem('token');
        if (!token) {
            next({path: '/login'})
            document.body.style.background = '#1F2D3D';
        } else {
            next()
            document.body.style.background = '#FFFFFF';
        }
    }

})

router.afterEach(transition => {
    NProgress.done();
});

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js